import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOSchema from '@/components/feature/SEOSchema';
import { articlesData } from '@/mocks/articles';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = articlesData.find((a) => a.id === Number(id));

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-20 text-center">
          <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">文章未找到</h1>
          <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium cursor-pointer">
            返回首页
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Organization" />
      <SEOSchema
        type="Article"
        data={{
          headline: article.title,
          description: article.summary,
          datePublished: article.date,
          author: article.author,
          image: article.image,
          publisher: {
            '@type': 'Organization',
            name: '云开体育',
          },
        }}
      />

      <Navbar />
      <Breadcrumb
        items={[
          { label: '首页', to: '/' },
          { label: article.categoryName, to: `/category/${article.category}` },
          { label: article.title },
        ]}
      />

      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8">
        <article>
          <header className="mb-8">
            <div className="flex items-center gap-2 mb-4 flex-wrap">
              {article.tags.map((tag) => (
                <span key={tag} className="px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                  {tag}
                </span>
              ))}
            </div>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4 leading-tight">
              {article.title}
            </h1>
            <div className="flex items-center gap-5 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-user-line"></i> {article.author}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i> {article.date}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i> 阅读约{article.readTime}
              </span>
            </div>
          </header>

          <div className="rounded-xl overflow-hidden mb-8">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-auto object-cover"
              style={{ maxHeight: '400px' }}
            />
          </div>

          <div
            className="prose prose-lg max-w-none text-foreground-800 leading-relaxed
              [&_h3]:font-heading [&_h3]:text-xl [&_h3]:font-bold [&_h3]:text-foreground-900 [&_h3]:mt-8 [&_h3]:mb-4
              [&_p]:mb-4 [&_p]:leading-relaxed
              [&_strong]:text-foreground-900"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          <footer className="mt-12 pt-8 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div>
                <p className="text-sm text-foreground-500 mb-1">本文由云开体育原创发布</p>
                <p className="text-xs text-foreground-400">未经授权，禁止转载</p>
              </div>
              <Link
                to={`/category/${article.category}`}
                className="flex items-center gap-1.5 text-primary-600 font-medium text-sm hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i> 返回{article.categoryName}
              </Link>
            </div>
          </footer>
        </article>
      </main>

      <Footer />
    </>
  );
}